<!--
SPDX-FileCopyrightText: 2025 Land Baden-Württemberg <InnoLab@stm.bwl.de>

SPDX-License-Identifier: MPL-2.0
-->

<script>
import uiStore from '../utils/UIStore';

import { renderMarkdown } from '../utils/markdownParser';
export let currentTab = 0;

let uiTexts;
uiStore.textStore.subscribe((store) => {
  uiTexts = store.texts;
});

let cookiesText = '';
let cookiesLink = '';
//load ui texts from ui Store
uiStore.textStore.subscribe((store) => {
  if (store.texts != null) {
    cookiesText = renderMarkdown(store.texts.cookies);
    cookiesLink = store.texts.cookiesLink;
  }
});
</script>

{#if currentTab != 7 && currentTab != 4}
  <!--Don't show cookies popup on nutzungsbedingung or datenschutz or faq page-->>
  <div class="pop_up_bg">
    <div class="pop_up_window">
      <div class="pop_up_content">
        <div class="p_popup">
          <p class="textlink">
            {@html cookiesText}
          </p>
        </div>
        <div class="row center" style="gap:20px">
          <slot name="agree" />
          <a href={cookiesLink} class="standard_button_light btn_link"
            >{uiTexts.popup.rejectAndLeave}</a
          >
        </div>
      </div>
    </div>
  </div>
{/if}

<style>
  .btn_link {
    font-weight: 600;
    text-transform: uppercase;
    font-size: 16px;
    align-items: center;
    display: flex;
  }
</style>
